import {ChangeDetectionStrategy, Component, Inject, Input, OnInit} from "@angular/core";
import {NgxPermissionsService} from "ngx-permissions";
import {RouterService} from "../../../../commons/angular/services/router.service";

@Component({
  standalone: false,
  selector: 'app-service-chat-button',
  templateUrl: './service-chat-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceChatButtonComponent implements OnInit {

  @Input() serviceId: string;

  public hasChatPermission: boolean;

  constructor(@Inject(NgxPermissionsService) private permissionsService: NgxPermissionsService,
              @Inject(RouterService) private routerService: RouterService
  ) {
  }

  ngOnInit() {
  }

  onClick(event) {
    event.stopPropagation();
    this.routerService.routeToNewTab('service.delivery.chat', {id: this.serviceId});
  }

}
